var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-loading"
  }, [_c('span', [_vm._v(_vm._s(this.message ? this.message : "No Data"))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }